<template>
    <div v-if="numbers">
        <v-row class="no-frame" v-for="(number, index) in preview" :key="index">
            <v-col class="no-frame col-auto">
                <v-icon size="16" style="margin-top: -7px">X {{ number.type.symbol }}</v-icon>
            </v-col>

            <v-col class="no-frame col-auto" style="font-size: 14px;">
                <div class="v-flex">
                    <f-copy-text :text="phone(number.number)" :color="color" />
                    <div v-if="numbers.length > 3 && index === 2" class="ml-1" :class="color">
                        {{ '(+' + (numbers.length - 3) + ")"  }}
                    </div>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>

import getUnicodeFlagIcon from 'country-flag-icons/unicode'
import Core from "@/modules/core/service/Core";
import FCopyText from "@/modules/core/components/utils/FCopyText";
import { AsYouType } from 'libphonenumber-js'

export default {
    name: "RPhoneNumber",
    components: {
        FCopyText
    },

    props: {
        numbers: {

        },
        color: {
            type: String,
            default: function () {
                return "primary";
            }
        }
    },

    computed: {
        sortedNumbers () {
            return this.numbers.slice().sort ((l,r) => { return l.rank - r.rank; });
        },

        preview () {
            return this.sortedNumbers.slice(0,3);
        },

        countries () {
            return this.$store.getters ['msd']['countries'];
        }
    },

    methods: {
        unicode (number) {
            let unicode = Core.message.language();

            if (number.startsWith("+")) {
                const countryPhone = number.substr(0, 3);
                const country = this.countries.find (c => c.phone === countryPhone);
                if (country) {
                    return country.iso3166;
                }
            }

            return unicode;
        },

        flag (number) {
            let unicode = this.unicode(number);
            if (!unicode) {
                return null;
            }

            return getUnicodeFlagIcon(unicode);
        },

        phone (number) {
            let unicode = this.unicode(number);
            if (unicode) {
                const n = number.replace("-", "").replace(" ", "")
                return new AsYouType(unicode).input(n);
            }

            return number;
        }
    }
}
</script>

<style scoped>

</style>